import React, { Component } from 'react';
import {  BrowserRouter as Router, Route } from 'react-router-dom'
import './App.css';

import Menu from "./components/Menu";

import Characters from "./components/Characters";
import Box from "./components/Box";
import Reports from "./components/Reports";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPaw, faFile, faQuestion, faDotCircle, faBan, faMap, faUsers, faExclamation, faUserPlus, faMinusCircle, faPlusCircle, faAnchor, faQuestionCircle, faExclamationTriangle, faCertificate, faFire, faTrash, faBoxOpen, faPlus, faGlobeAsia, faComments, faCalendar, faShoppingCart, faCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faPaw, faFile, faQuestion, faDotCircle, faBan, faMap, faUsers, faExclamation, faUserPlus, faMinusCircle, faPlusCircle, faAnchor, faQuestionCircle, faExclamationTriangle, faCertificate, faFire, faTrash, faBoxOpen, faPlus, faGlobeAsia, faComments, faCalendar, faShoppingCart, faCircle)

class App extends Component {
	
	render() {
		return (
		<Router>
			<div className="App">
				<div className="Header">
					<div className="Header-Inner">
						<div className="AppTitle">La Société Planaire</div>
						<Menu />
					</div>
				</div>
				<Route exact path="/" component={Characters} />
				<Route exact path="/personnages" component={Characters} />
				<Route exact path="/objets" component={Box} />
				<Route exact path="/carnets" component={Reports} />
				<Route exact path="/planaire" component={Characters} />
				<Route exact path="/planaire/personnages" component={Characters} />
				<Route exact path="/planaire/objets" component={Box} />
				<Route exact path="/planaire/carnets" component={Reports} />
			</div>
		</Router>
		);
	}
}

export default App;
